import { ReturnAddressSchema } from "@redotech/redo-model/return";
import * as z from "zod/v4";

export enum UpdateReturnExchangeAddressErrorCode {
  ReturnNotFound = "ReturnNotFound",
  Unauthorized = "Unauthorized",
  NotEditable = "NotEditable",
}

export const updateReturnExchangeAddress = {
  name: "updateReturnExchangeAddress" as const,
  input: z.object({
    returnId: z.string(),
    newOrderAddress: ReturnAddressSchema,
  }),
  output: z.object({ success: z.boolean() }),
};
